import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {
  CreatePaymentErrorResponse,
  CreatePaymentRequest,
  CreatePaymentResponse,
  Link,
} from '../models/create-payment.model';
import { ExecutePaymentRequest } from '../models/execute-payment.model';
import { ApiResponse } from '../models/response.model';
import { PayPalApiService } from '../services/paypal.api.service';


@Component({
  selector: 'paypal-form-pay',
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.scss']
})
export class PayPalComponent implements OnInit, OnDestroy {
  @Input() accessToken: string;
  @Input() vkUrlApi: string;
  @Input() debugLog: boolean;
  @Input() storeId: string;
  @Input() idVen: number;
  @Input() data: string;
  @Input() title: string;
  @Input() amount: string;
  @Input() currency: string;
  @Input() returnUrl: string;
  @Input() successUrl: string;
  @Input() failureUrl: string;

  paymentRequest: CreatePaymentRequest;
  executePaymentRequest: ExecutePaymentRequest;
  errorsMessage: any;

  showMessage: boolean = false;
  loading: boolean = true;
  status: string = '';

  linkToPay: string = '';
  linkExecutePay: string = '';

  constructor(private route: ActivatedRoute, private router: Router, private payPalApiService: PayPalApiService) {
    if (!this.getPaymentState()) {
      this.setPaymentState('initial');
    }
  }

  ngOnInit(): void {
    this.initialize();
  }

  ngOnDestroy(): void {
    this.setPaymentState('initial');
  }

  private initialize(): void {
    this.route.queryParams.subscribe(params => {

      //- si es una cancelacion, eliminamos flag
      if (params['cancel']) {
        this.setPaymentState('initial');
      }

      this.executePaymentRequest = {
        payerId: params['PayerID'],
        paymentId: params['paymentId'],
        token: params['token']
      };

      if (this.getPaymentState() == 'initial') {
        this.createPayment();
      } else {
        this.loading = false;
      }
    });
  }

  private createPayment(): void {
    this.paymentRequest = {
      description: this.title,
      amount: this.amount,
      currency: this.currency,
      cancelUrl: `${this.payPalApiService.normalizeUrl(this.returnUrl)}/?cancel=true`,
      returnUrl: this.returnUrl,
      storeId: this.storeId,
      idVen: this.idVen,
      data: this.data
    };

    this.logger('CreatePayment', this.paymentRequest);
    this.payPalApiService.createdPayment(this.paymentRequest, this.accessToken, this.vkUrlApi)
      .subscribe((res: ApiResponse) => {
        this.paymentResponseHandler(res);
      },
        error => {
          this.logger('CreatePaymentError', error);
          this.router.navigate([`${this.failureUrl}`]);
        });
  }

  private paymentResponseHandler(res: ApiResponse) {
    this.loading = false;
    this.logger('PaymentResponseHandler', res);

    if (res.success) {
      this.showMessage = false;
      const paymentPayPal = (res.data as CreatePaymentResponse);
      this.linkToPay = paymentPayPal.links.find(x => x.rel === "approval_url").href;
      this.linkExecutePay = paymentPayPal.links.find(x => x.rel === "execute").href;
    } else {
      this.errorsMessage = (JSON.parse(res.errorsMessages[0]) as CreatePaymentErrorResponse).details;
      this.showMessage = true;
    }
  }

  goToPayPal(): void {
    this.loading = true;
    this.setPaymentState('created');
    window.location.replace(this.linkToPay);
  }

  executePay(): void {
    this.loading = true;
    this.setPaymentState('execute');

    this.logger('ExecutePay - Request', this.executePaymentRequest);

    this.payPalApiService.executePayment(this.executePaymentRequest, this.accessToken, this.vkUrlApi)
      .subscribe((res: ApiResponse) => {
        this.loading = false;
        this.showMessage = true;

        this.logger('ExecutePay - Response', res);

        if (res.success) {
          sessionStorage.removeItem('payState');
          this.router.navigate([`${this.successUrl}`]);
        } else {
          this.router.navigate([`${this.failureUrl}`]);
        }
      },
        error => {
          this.logger('ExecutePaymentError', error);
          this.router.navigate([`${this.failureUrl}`]);
        });
  }

  getPaymentState(): string | null {
    return sessionStorage.getItem('payState');
  }

  setPaymentState(state: string): void {
    this.logger('setPaymentState', state);
    sessionStorage.setItem('payState', state);
  }

  private logger(message: string, data: any): void {
    if (this.debugLog && data != null) {
      console.log(message, JSON.stringify(data));
    }
  }
}
